import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import { useSelector } from 'react-redux';
import { useEmployerInfoData, useGetConfigSettingData } from 'hooks';
import { AppInfoType } from 'common';
import { RootState } from 'modules';
import PaywatchIcon from 'assets/paywatchIcon.svg';
import PaywatchIconWithLabel from 'assets/logo-w-label.png';
import SkinStyles from 'components/SkinStyles';
import { useColorPrimary } from 'contexts/ColorPrimaryContext';

export const SidebarIcon: React.FC<{ collapsed?: boolean }> = ({ collapsed = false }) => {
  const [icon, setIcon] = useState<string>(PaywatchIcon);
  const { eid } = useSelector((state: RootState) => state.user);
  const { data: employerInfoData } = useEmployerInfoData(eid ?? '');
  const { data: whiteLabelData } = useGetConfigSettingData(AppInfoType.WHITE_LABEL_LIST);
  const { setColorPrimary } = useColorPrimary();

  useEffect(() => {
    const defaultIcon = collapsed ? PaywatchIcon : PaywatchIconWithLabel;

    if (!eid || !employerInfoData) {
      setColorPrimary(SkinStyles.Default.colorPrimary);
      setIcon(defaultIcon);
      return;
    }

    const allWhiteLabel = whiteLabelData && 'data' in whiteLabelData ? whiteLabelData.data : [];
    const usedWhiteLabel = allWhiteLabel.find((item) => item.value === employerInfoData?.setting?.whiteLabel);

    const primaryColor =
      usedWhiteLabel?.value === 'CHBKPH' ? SkinStyles.ChinaBank.colorPrimary : SkinStyles.Default.colorPrimary;
    setColorPrimary(primaryColor);

    if (usedWhiteLabel) {
      setIcon(collapsed ? usedWhiteLabel.thumbnail : usedWhiteLabel.image);
    } else {
      setIcon(defaultIcon);
    }
  }, [eid, whiteLabelData, employerInfoData, collapsed, setColorPrimary]);
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '64px' }}>
      <Image
        src={icon}
        preview={false}
        style={{ maxWidth: collapsed ? '16px' : '150px', maxHeight: '32px', margin: '16px 0px' }}
        className={collapsed ? 'img-icon' : 'img-logo'}
        alt="logo"
      />
    </div>
  );
};
